export default class y {
  constructor() {}
  Rs() {}
  changeUser(a) {}
  clearData() {}
}
